<template>
  <AppBar :color="color">
    <v-row class="d-flex justify-end">
      <v-col
        v-if="$root.isDesktop"
        cols="12"
        md="4"
        class="d-flex justify-center"
      >
        <v-row dense>
          <v-col class="d-flex">
            <sc-btn
              v-if="showRegistration"
              to="/signup"
              outlined
              max-width="180px"
              width="100%"
              >{{ $t("public.header.registration") }}</sc-btn
            >
          </v-col>
          <v-col class="d-flex">
            <sc-btn @click="$root.toLogin" max-width="180px" width="100%">{{
              $t("public.header.login")
            }}</sc-btn>
          </v-col>
          <v-col cols="1" class="ml-3">
            <LanguageSelector :color="color" />
          </v-col>
        </v-row>
      </v-col>
      <v-col
        cols="6"
        sm="3"
        class="d-flex flex-row justify-end align-center"
        v-else
      >
        <LanguageSelector :color="color" />
      </v-col>
    </v-row>
  </AppBar>
</template>

<script>
import AppBar from "@/components/AppBar";
import LanguageSelector from "@/components/LanguageSelector";
export default {
  props: {
    color: String,
  },
  components: {
    AppBar,
    LanguageSelector,
  },
  methods:{
    
  },  
  computed: {
    showRegistration: (vm) => vm.$route.path === "/",
  },
};
</script>

<style></style>
